export const ENTITY_TYPE_SELLER = 'ENTITY_TYPE_SELLER'